export const testDataMenuI18n = {
  testData: 'Create test data',
  testDataPage: {
    title: 'Create test data',
    description:
      'Each block maps to a module cluster. Before creating, the system checks existing records (code, name) and only adds what is missing — data looks like production data.',
    skipExistingBadge: 'Skips records that already exist',
    sectionBundle: 'Quick start',
    sectionNhomHang: 'Product groups',
    sectionHangHoa: 'Products',
    sectionKho: 'Warehouse',
    sectionCustomer: 'Customers',
    sectionSupplier: 'Suppliers',
    btnBundleAll: 'Basic bundle ({dm} groups + {nkh} cust. cat. + {ncc} suppliers)',
    btnDmNhomHang: 'Product categories ({total})',
    btnHangHoa: 'Products ({perCat}/cat × {cats} leaf cats)',
    btnThuongHieu: 'Brands ({count})',
    btnDonViTinh: 'Units ({count})',
    btnViTri: 'Locations ({count})',
    btnDmKhachHang: 'Customer categories ({count})',
    btnKhachHang: 'Customers ({per}/category)',
    btnDmNcc: 'Supplier categories ({count})',
    btnNcc: 'Suppliers ({count})',
    seedAll: 'Basic bundle: {dm} L1 groups + {nkh} customer groups + {ncc} suppliers',
    seedAllHint: 'Runs 3 steps in order; skips items that already exist.',
    seedNhomHangDanhMuc: 'Product groups level 1 only — {count} root categories (no children)',
    seedNhomHangTree3: '3-level product tree — {total} industry groups',
    seedNhomHangTree3Hint: 'Real industry names; safe to run again.',
    seedSanPham: 'Products by category — {perCat} items × {cats} categories ({total} products)',
    seedSanPhamHint: 'Requires 3-level tree; checks product codes first.',
    seedThuongHieu: 'Brands — {count} brands (common names)',
    seedDonViTinh: 'Units of measure — {count} units (retail common)',
    seedViTri: 'Warehouse locations — {count} slots (10 zones × 10 shelves)',
    seedViTriHint: 'Codes VT-A01 … VT-J10.',
    seedNhomHangTree: 'Product tree 4 levels — large dataset ({total} groups, slow)',
    seedNhomKhachHang: 'Customer groups — {count} segments',
    seedNhomKhachHangHint: 'Create groups before seeding customers.',
    seedKhachHang: 'Customers by group — {perGroup} × {groups} groups ({total} customers)',
    seedKhachHangHint: 'Realistic names, phones, emails; linked to the right group.',
    seedNhaCungCap: 'Suppliers — {total} suppliers (real company names & codes)',
    seedNhaCungCapHint: 'Real company names & supplier codes.',
    progress: '{done} / {total}',
    logTitle: 'Results',
    success: 'Done — see detailed log below',
    failed: 'Failed to create test data',
    partialSuccess: 'Some actions failed — see log below',
  },
} as const
